{
  "postTrading": {
    "empty": "There are no options events",
    "infoText": "Info",
    "total": "Total",
    "columns": {
      "option": "Option",
      "options": "Options",
      "stocks": "Stocks",
      "sum": "Amount",
      "price": "Price",
      "event": "Event",
      "date": "Date"
    },
    "events": {
      "OPEXP": "Expired",
      "OPEXC": "Executed",
      "OPASN": "Settled",
      "expired": "Expired",
      "exercises": "Exercises",
      "assigned": "Assigned"
    },
    "errors": {
      "postTradingEvents": "Failed to fetch option events"
    }
  }
}
